/* To avoid CSS expressions while still supporting IE 7 and IE 6, use this script */
/* The script tag referring to this file must be placed before the ending body tag. */

/* Use conditional comments in order to target IE 7 and older:
	<!--[if lt IE 8]><!-->
	<script src="ie7/ie7.js"></script>
	<!--<![endif]-->
*/

(function() {
	function addIcon(el, entity) {
		var html = el.innerHTML;
		el.innerHTML = '<span style="font-family: \'icomoon\'">' + entity + '</span>' + html;
	}
	var icons = {
		'icon-mosaic': '&#xe607;',
		'icon-arrow-down4': '&#xe603;',
		'icon-earth': '&#xe602;',
		'icon-googleplus': '&#xe608;',
		'icon-facebook': '&#xe609;',
		'icon-twitter': '&#xe60a;',
		'icon-feed': '&#xe60b;',
		'icon-arrow-up': '&#xe720;',
		'icon-arrow-up-right': '&#xe721;',
		'icon-arrow-right': '&#xe722;',
		'icon-arrow-down-right': '&#xe723;',
		'icon-arrow-down': '&#xe724;',
		'icon-arrow-down-left': '&#xe725;',
		'icon-arrow-left': '&#xe726;',
		'icon-arrow-up-left2': '&#xe727;',
		'icon-arrow-up2': '&#xe728;',
		'icon-arrow-up-right2': '&#xe729;',
		'icon-arrow-right2': '&#xe72a;',
		'icon-arrow-down-right2': '&#xe72b;',
		'icon-arrow-down2': '&#xe72c;',
		'icon-arrow-down-left2': '&#xe72d;',
		'icon-arrow-left2': '&#xe72e;',
		'icon-arrow-up-left3': '&#xe72f;',
		'icon-arrow-up3': '&#xe730;',
		'icon-arrow-up-right3': '&#xe731;',
		'icon-arrow-right3': '&#xe732;',
		'icon-arrow-down-right3': '&#xe733;',
		'icon-arrow-down3': '&#xe734;',
		'icon-arrow-down-left3': '&#xe735;',
		'icon-arrow-left3': '&#xe736;',
		'icon-arrow-up-left': '&#xe71f;',
		'icon-home': '&#xe600;',
		'icon-pencil': '&#xe605;',
		'icon-undo2': '&#xe666;',
		'icon-redo2': '&#xe667;',
		'icon-forward': '&#xe668;',
		'icon-reply': '&#xe669;',
		'icon-twitter2': '&#xe76d;',
		'icon-feed2': '&#xe770;',
		'icon-search': '&#xe67f;',
		'icon-zoomin': '&#xe680;',
		'icon-zoomout': '&#xe681;',
		'icon-tag': '&#xe630;',
		'icon-tags': '&#xe631;',
		'icon-phone': '&#xe63c;',
		'icon-calendar': '&#xe64e;',
		'icon-bubble': '&#xe66a;',
		'icon-bubbles': '&#xe66b;',
		'icon-bubbles2': '&#xe66c;',
		'icon-bubble2': '&#xe66d;',
		'icon-bubbles3': '&#xe66e;',
		'icon-bubbles4': '&#xe66f;',
		'icon-user': '&#xe670;',
		'icon-users': '&#xe671;',
		'icon-user3': '&#xe674;',
		'icon-user4': '&#xe675;',
		'icon-cog2': '&#xe690;',
		'icon-cogs': '&#xe68f;',
		'icon-cog': '&#xe68e;',
		'icon-wrench': '&#xe68b;',
		'icon-switch': '&#xe6b1;',
		'icon-star': '&#xe6ce;',
		'icon-star2': '&#xe6cf;',
		'icon-star3': '&#xe6d0;',
		'icon-menu2': '&#xe6b8;',
		'icon-menu': '&#xe6b7;',
		'icon-cloud-download': '&#xe6bb;',
		'icon-cloud-upload': '&#xe6bc;',
		'icon-download2': '&#xe6bd;',
		'icon-upload2': '&#xe6be;',
		'icon-download3': '&#xe6bf;',
		'icon-upload3': '&#xe6c0;',
		'icon-flag': '&#xe6c4;',
		'icon-eye': '&#xe6c6;',
		'icon-minus': '&#xe701;',
		'icon-plus': '&#xe702;',
		'icon-checkmark': '&#xe6fe;',
		'icon-checkmark2': '&#xe6ff;',
		'icon-enter': '&#xe703;',
		'icon-exit': '&#xe704;',
		'icon-feed3': '&#xe771;',
		'icon-twitter22': '&#xe76e;',
		'icon-twitter3': '&#xe76f;',
		'icon-feed4': '&#xe772;',
		'icon-tumblr': '&#xe792;',
		'icon-tumblr2': '&#xe793;',
		'icon-googleplus2': '&#xe764;',
		'icon-googleplus3': '&#xe766;',
		'icon-googleplus4': '&#xe767;',
		'icon-facebook2': '&#xe76a;',
		'icon-facebook3': '&#xe76b;',
		'icon-home2': '&#xe601;',
		'icon-pencil2': '&#xe606;',
		'icon-location': '&#xe642;',
		'icon-location2': '&#xe643;',
		'icon-pushpin': '&#xe641;',
		'icon-compass': '&#xe644;',
		'icon-map': '&#xe645;',
		'icon-map2': '&#xe646;',
		'icon-envelope': '&#xe640;',
		'icon-print': '&#xe650;',
		'icon-unlocked': '&#xe68a;',
		'icon-lock': '&#xe688;',
		'icon-link': '&#xe6c3;',
		'icon-attachment': '&#xe6c5;',
		'icon-bookmark': '&#xe6c9;',
		'icon-bookmarks': '&#xe6ca;',
		'icon-info': '&#xe6f7;',
		'icon-info2': '&#xe6f8;',
		'icon-cancel-circle': '&#xe6fa;',
		'icon-checkmark-circle': '&#xe6fb;',
		'icon-close': '&#xe6fd;',
		'icon-play3': '&#xe70a;',
		'icon-pause2': '&#xe70b;',
		'icon-stop2': '&#xe70c;',
		'icon-backward2': '&#xe70d;',
		'icon-forward3': '&#xe70e;',
		'icon-first': '&#xe70f;',
		'icon-last': '&#xe710;',
		'icon-previous': '&#xe711;',
		'icon-next': '&#xe712;',
		'icon-newtab': '&#xe75a;',
		'icon-facebook4': '&#xe769;',
		'icon-file-pdf': '&#xe7b2;',
		'icon-file-word': '&#xe7b4;',
		'icon-file-excel': '&#xe7b5;',
		'icon-file-xml': '&#xe7b8;',
		'icon-file-zip': '&#xe7b6;',
		'icon-file-powerpoint': '&#xe7b7;',
		'icon-file-openoffice': '&#xe7b3;',
		'icon-libreoffice': '&#xe7b1;',
		'icon-newspaper': '&#xe604;',
		'icon-clock': '&#xe648;',
		'icon-clock2': '&#xe649;',
		'icon-share': '&#xe75e;',
		'icon-googleplus22': '&#xe765;',
		'icon-minus2': '&#xe60c;',
		'icon-plus2': '&#xe60d;',
		'icon-cross': '&#xe60e;',
		'icon-minus3': '&#xe60f;',
		'icon-plus3': '&#xe610;',
		'icon-cross2': '&#xe611;',
		'0': 0
		},
		els = document.getElementsByTagName('*'),
		i, c, el;
	for (i = 0; ; i += 1) {
		el = els[i];
		if(!el) {
			break;
		}
		c = el.className;
		c = c.match(/icon-[^\s'"]+/);
		if (c && icons[c[0]]) {
			addIcon(el, icons[c[0]]);
		}
	}
}());
